var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campus-wrapper"},[(_vm.parentArr.length > 0)?_c('thumb-swiper',{attrs:{"swiperList":_vm.displayArr,"parentArr":_vm.parentArr,"no-scroll":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }